import { routes } from '@/app/routing/router'
import { CasesListPageView } from './view'

const currentRoute = routes.caseList

const CasesListPageRoute = {
  route: currentRoute,
  view: CasesListPageView,
}

export { currentRoute, CasesListPageRoute }
